import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppointmentInfo } from '../schedule/AppointmentInfo';
import { AddressInfo } from './AddressInfo';
import { UserInfo } from './UserInfo';
import { SignInInfo } from '../login/signin/signinInfo';
import { BehaviorSubject } from 'rxjs';
import { UserToken } from '../login/UserToken';
import { UserData } from './user.data';
import { SignUpInfo } from '../login/signup/SignupInfo';
import { DatePipe } from '@angular/common';
import jwt_decode from 'jwt-decode';
import * as CryptoJS from 'crypto-js';
import { Constants } from '../app.constants';
import { OrgInfo } from '../organization/org-info';
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public imageUrl = new BehaviorSubject<any>(null);
  public isSpinnerHide = new BehaviorSubject<any>(false);
  private _appointmentId: number;
  public get appointmentId(): number {
    return this._appointmentId;
  }
  public set appointmentId(v: number) {
    this._appointmentId = v;
  }
  private userApiUrl = environment.apibaseUrl + '/user';
  private caseApiUrl = environment.apibaseUrl + '/casemanagement';
  private baseUrl = environment.apibaseUrl;
  // for testing purposes
  private testUrl = environment.apibaseUrl;

  public CurrentUserAddress: AddressInfo = null;
  public userInfoLoaded = new BehaviorSubject<any>(null);
  public isReadyForEmergency = false;
  public IsOrgSwitched = false;
  public isHelpFromSignin = false;
  private _currentUser: UserData;
  public userInfo = new BehaviorSubject<UserData>(null);
  get CurrentUser(): UserData {
    return this._currentUser;
  }
  set CurrentUser(user: UserData) {
    this._currentUser = user;
    this.userInfoLoaded.next(user);
  }
  public OrgName = new BehaviorSubject<string>(null);
  public OrgInfo = new BehaviorSubject<OrgInfo>(null);
  public IsCheckOrgType = false;
  constructor(private http: HttpClient, public datepipe: DatePipe) { }

  signIn(signinInfo: SignInInfo) {
    this.isHelpFromSignin = false;
    return this.http.post(this.userApiUrl + '/authenticate', signinInfo);
  }

  createUser(userInfo: UserInfo) {
    return this.http.post(this.userApiUrl, userInfo);
  }

  updateUser(userInfo: UserInfo, addressInfo: AddressInfo) {
    return this.http.put(this.userApiUrl, { userInfo, addressInfo });
  }

  updateUserProfile(userInfo: UserInfo, addressInfo: AddressInfo) {
    return this.http.put(this.userApiUrl + '/userprofile', { userInfo, addressInfo });
  }

  getUserProfileInfo() {
    return this.http.get(this.userApiUrl + '/profileInfo');
  }

  // this is for getting the appUser info
  getUserInfo() {
    return this.http.get(this.userApiUrl + '/Info');
  }

  // this is for getting any user info
  getAnyUserInfo(id: number) {
    return this.http.get(this.userApiUrl + '/Info/' + id);
  }

  getAddressInfo(id: number): any {
    return this.http.get(this.userApiUrl + '/address/' + id);
  }

  // delete user
  deleteUser(id: number) {
    const loginTime = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
    return this.http.delete(this.userApiUrl + '/?userid=' + id + '&loginTime=' + loginTime);
  }

  scheduleAppoinment(appointmentInfo: AppointmentInfo) {
    return this.http.post(this.testUrl + '/appointment', appointmentInfo);
  }

  setProfileImg(image) {
    const formdata = new FormData();
    formdata.append('image', image);
    return this.http.post(this.userApiUrl + '/image', formdata);
  }

  getProfileImage() {
    return this.http.get(this.userApiUrl + '/profile-image');
  }

  setAuthToken(token: string) {
    localStorage.setItem('AuthToken', token);
  }

  getAuthToken() {
    return localStorage.getItem('AuthToken');
  }

  setIpaddress() {
    const publicIp = require('public-ip');
    return new Promise((resolve, reject) => {
      (async () => {
        const ipAddress = await publicIp.v4();
        localStorage.setItem('ipaddress', ipAddress);
        resolve(ipAddress);
      })();
    });

  }

  getIpaddress() {
    return localStorage.getItem('ipaddress');
  }

  public getRole() {
    if (this.getAuthToken()) {
      const token = this.getAuthToken();
      const decodetoken = jwt_decode(token);
      return (decodetoken as any).rolename;
    }
    return null;
  }

  public getBrowserType() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  setSessionItem(item: string, key: string) {
    localStorage.setItem(key, item);
  }

  getSessionItem(key: string) {
    return localStorage.getItem(key);
  }

  setSessionStorageItem(item: string, key: string) {
    sessionStorage.setItem(key, item);
  }

  getSessionStorageItem(key: string) {
    return sessionStorage.getItem(key);
  }

  getUserToken(token: string) {
    return this.http.get(this.userApiUrl + '/validation/' + token);
  }

  setUserPassword(userToken: UserToken) {
    return this.http.post(this.userApiUrl + '/password', userToken);
  }

  resetUserPassword(userInfo: UserInfo) {
    return this.http.post(this.userApiUrl + '/resetpassword', userInfo);
  }

  switchOrganization(orgId: number) {
    return this.http.get(this.userApiUrl + '/switchorg/' + orgId);
  }

  launchApp() {
    return this.http.get(this.userApiUrl + '/launchApp2/');
  }

  switchToSysAdmin() {
    return this.http.get(this.userApiUrl + '/swittosysadmin');
  }

  public enableEmergency(enable: boolean) {
    this.isReadyForEmergency = enable;
    return this.http.post(this.userApiUrl + '/EmergencyEnable?enable=' + enable, null);
  }

  public teleMedicine(enable: boolean) {
    this.isReadyForEmergency = enable;
    return this.http.post(this.userApiUrl + '/TeleMedicineEnable?enable=' + enable, null);
  }

  // resendInvitation(user: any) {
  //   return this.http.post(this.userApiUrl + "/resendInvitation", user);
  // }

  resendMultipleInvitation(user: any) {
    return this.http.post(this.userApiUrl + '/multipleInvitationResend', user);
  }

  public getSessionId(): any {
    return this.http.get(this.userApiUrl + '/SessionId');
  }

  public getUserTimezone(): any {
    return this.http.get(this.userApiUrl + '/timezone');
  }

  public getIPAddress() {
    return this.http.get('http://api.ipify.org/?format=json');
  }

  public getUserLicenceNumberandName(clinicianId?): any {
    if (clinicianId == undefined || clinicianId == null) {
      clinicianId = 0;
    }
    return this.http.get(this.userApiUrl + '/LicencenumberandName?clinicianId=' + clinicianId);
  }

  public getUsername(clientId?: number): any {
    if (clientId == undefined || clientId == 0) {
      clientId = 0;
    }
    return this.http.get(this.userApiUrl + '/clientName?clientId=' + clientId);
  }

  public getRelationList(): any {
    return this.http.get(this.userApiUrl + '/relations');
  }

  public getStateList() {
    return this.http.get(this.userApiUrl + '/stateList');
  }

  saveLicense(licenseInfo) {
    return this.http.post(this.userApiUrl + '/licenseInfo', licenseInfo);
  }

  getLicenseList() {
    return this.http.get(this.userApiUrl + '/licenseList');
  }

  deleteLicense(id: number) {
    return this.http.delete(this.userApiUrl + '/deleteLicense?licenseInfoId=' + id);
  }

  getLicenseInfoById(id: number) {
    return this.http.get(this.userApiUrl + '/licenseInfo?licenseInfoId=' + id);
  }

  updateLicense(licenseInfo) {
    return this.http.put(this.userApiUrl + '/updateLicense', licenseInfo);
  }

  public checkUnmappedClinicianWithPatient(userId, clinics) {
    const info: any = {
      ApportisUserId: userId,
      Clinics: clinics,
    };
    return this.http.post(this.userApiUrl + '/checkUnmappedClinicianWithPatient', info);
  }

  // SignupService

  public getNeedAssistanceIssueCategory(orgId) {
    return this.http.get(this.userApiUrl + '/NeedAssistanceIssueCategory/' + orgId);
  }

  public GetDefaultQuestionAnswer(orgid, isReferalDefault = false, formName = null) {
    return this.http.get(this.userApiUrl + '/GetDefaultQuestionAnswer/?orgid=' + orgid + '&isReferalDefault=' + isReferalDefault + '&formName=' + formName);
  }

  public getcountyDetails(orgid) {
    return this.http.get(this.userApiUrl + '/Countydetails/' + orgid);
  }

  public getcountyList() {
    return this.http.get(this.userApiUrl + '/CountyList/');
  }

  public SignupUser(userInfo: SignUpInfo) {
    return this.http.post(this.userApiUrl + '/signup/', userInfo);
  }

  getParicipantDetails(patientId: number) {
    return this.http.get(this.caseApiUrl + '/participantInfo?participantId=' + patientId);
  }

  getParicipantCaseDetails(patientId: number) {
    return this.http.get(this.caseApiUrl + '/profilecaselist?participantId=' + patientId);
  }

  saveCaseNotes(noteInfo) {
    return this.http.post(this.baseUrl + '/patient/createcasenote', noteInfo);
  }

  Casequestionandanswer(caseId: number) {
    return this.http.get(this.caseApiUrl + 'case/questionandanswer?caseId=' + caseId);
  }

  refreshCaseNoteList(caseId) {
    return this.http.get(this.caseApiUrl + '/caseNoteList?caseId=' + caseId);
  }

  getActionTypeList(caseId) {
    return this.http.get(this.caseApiUrl + '/getActionTypeList?caseId=' + caseId);
  }

  getAgencyReferredList(countyId) {
    return this.http.get(this.caseApiUrl + '/getAgencyReferredList?countyId=' + countyId);
  }

  getActionTypeOptions(actionTypeId) {
    return this.http.get(this.caseApiUrl + '/getActionTypeOptions?actionTypeId=' + actionTypeId);
  }

  saveAction(actionInfo) {
    return this.http.post(this.caseApiUrl + '/saveAction', actionInfo);
  }

  closeCase(caseId) {
    const loginTime = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
    return this.http.get(this.caseApiUrl + '/closeCase?caseId=' + caseId + '&loginTime=' + loginTime);
  }

  getSavedActionData(caseId) {
    return this.http.get(this.caseApiUrl + '/caseActionInfo?caseId=' + caseId);
  }

  // Reconnect
  public getSessionIdForReconnect(clinicianId, appoinmentID): any {
    return this.http.get(this.userApiUrl + '/getsessionId?clinicianId=' + clinicianId + '&appoinmentID=' + appoinmentID);
  }

  public getSessionIdForReconnectWaitingRoom(waitingRoomId): any {
    return this.http.get(this.userApiUrl + '/getsessionIdReconnectwaitingroom?waitingRoomId=' + waitingRoomId);
  }

  // edit profile

  DefaultCaseAnswerAndQuestion(caseid: number) {
    return this.http.get(this.caseApiUrl + '/DefaultCaseAnswerAndQuestion?caseid=' + caseid);
  }

  Updateprofile(userinfo: UserInfo) {
    return this.http.post(this.caseApiUrl + '/update/profile', userinfo);
  }

  getGeneralquestions() {
    return this.http.get(this.caseApiUrl + '/getGeneralquestions');
  }

  public saveGeneralCase(data: any) {
    return this.http.post(this.caseApiUrl + '/saveGeneralCase', data);
  }

  // create connection id for user
  createConnection(id: string) {
    return this.http.get(this.userApiUrl + '/registerUser?connectionId=' + id);
  }

  // delete connection id for user
  deleteConnection(id?) {
    return this.http.get(this.userApiUrl + '/unRregisterUser?userId=' + id);
  }

  getGeneralQuestionAndAnswer(clientId: number) {
    return this.http.get(this.caseApiUrl + '/getGeneralQuestionAndAnswer?clientId=' + clientId);
  }

  onclosedevent(userId?) {
    fetch(this.userApiUrl + '/unRregisterUser?userId=' + userId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      keepalive: true
    });
  }

  updateUserConnection() {
    return this.http.get(this.userApiUrl + '/updateUserConnection');
  }

  activateUser(userId) {
    return this.http.get(this.userApiUrl + '/activateUser/?userId=' + userId);
  }

  gaEventEmitter(eventName, eventCategory, eventLabel, eventAction, eventValue, Organization = '') {
    if (Organization != '') {
      gtag('event', eventName, {
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventAction: eventAction,
        eventValue: eventValue,
        organization: Organization
      });
    } else {
      gtag('event', eventName, {
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventAction: eventAction,
        eventValue: eventValue
      });
    }
  }

  getRolenameByUserId(id: number): any {
    return this.http.get(this.userApiUrl + '/getroleName/' + id);
  }

  switchToOtherRole(roleId) {
    return this.http.get(this.userApiUrl + '/switchrole/?roleId=' + roleId);
  }

  public encryptCode(value) {
    const key = CryptoJS.enc.Utf8.parse(Constants.EncodeKey);
    const iv = CryptoJS.enc.Utf8.parse(Constants.EncodeKey);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

  public decryptCode(value) {
    const key = CryptoJS.enc.Utf8.parse(Constants.EncodeKey);
    const iv = CryptoJS.enc.Utf8.parse(Constants.EncodeKey);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  decode(value: string) {
    return this.http.get(this.userApiUrl + '/decode/?value=' + value);
  }

  public verifyUserName(userName, orgId: number = 0) {
    return this.http.get(this.userApiUrl + '/verifyUsername?userName=' + userName + '&clinicalOrgId=' + orgId);
  }

  public getCountryCodeList() {
    return this.http.get(this.userApiUrl + '/countryCodeList');
  }

  public getSuggestedUsername(firstName, lastName, orgId: number = 0) {
    return this.http.get(this.userApiUrl + '/suggestedUsername?firstName=' + firstName +
     '&lastName=' + lastName + '&clinicalOrgId=' + orgId);
  }

  public setActiveLogin() {
    return this.http.get(this.userApiUrl + '/setActiveLogin');
  }

  public deleteActiveLogin(userId?) {
    // return this.http.delete(this.userApiUrl + '/deleteActiveLogin');
    fetch(this.userApiUrl + '/deleteActiveLogin?userId=' + userId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      keepalive: true
    });
  }

  getToken(token: string) {
    return this.http.get(this.userApiUrl + '/getToken/' + token);
  }

}
